/* eslint-disable no-unused-vars */
import { useContext } from "react";
import routes from "../../routes/sidebar";
import MENU from "./Menu";
import { SidebarContext } from "../../context/SidebarContext";
import { ReactComponent as Closeicon } from "../../icons/leftArrow.svg";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { useQuery } from "react-query";
import getAPIMap from "../../api_map.js";
import ComvivaLogo from "assets/img/comviva-logo.svg";
import LeftArrow from "../../assets/img/Icon ionic-ios-arrow-down.svg";
import { RightArrow } from "../../icons/index.js";
import getIP from "../../getIP.js";
const IP = getIP();
import { useTheme } from "../../context/ThemeContext.js";
import { Link } from "react-router-dom";
import { clientSecret, getUser } from "../../lib/client-secret.js";

function SidebarContent() {
  const { closeSidebar } = useContext(SidebarContext);
  const { userDetails } = useContext(AuthContext);
  const { collapsed, setCollapsed } = useContext(AuthContext);
  const { theme } = useTheme();
  //const [twoLines, setTwoLines] = useState(false);
  let menudata = [];
  let isLineAdded = false;

  const { data, isLoading } = useQuery(["/menu", userDetails], async () => {
    const URL = IP + getAPIMap("menu");

    const config = {
      headers: {
        Authorization: `Bearer ${userDetails?.token}`,
      },
    };
    return await axios.get(URL, config);
  });

  const { data: userConfigData, isLoading: isUserLoading } = useQuery(
    ["getUser", userDetails],
    getUser,
    {
      enabled: !!userDetails?.token && !!userDetails?.sub,
    }
  );
  const serviceType =
    userConfigData?.data?.data?.config?.serviceType ??
    userConfigData?.data?.serviceType;
  // if (!isLoading) {
  //   menudata = data?.data?.data?.filter((e) => e.name !== "_Chat");
  // }

  if (!isLoading) {
    menudata = data?.data?.data
      ?.filter((e) => e.name !== "_Chat")
      ?.filter((e) => {
        // Hide Developers menu if serviceType === "0"
        if (
          serviceType === "0" &&
          (e.name === "_Service_Request" || e.path === "/app/service-request")
        ) {
          return false;
        }
        return true;
      });

    // Ensure AuthConfig appears directly after the Numbers menu items
    const authIdx = menudata?.findIndex((e) => e?.name === "AuthConfig") ?? -1;
    if (authIdx > -1) {
      const [authItem] = menudata.splice(authIdx, 1);
      let lastNumIdx = -1;
      menudata.forEach((e, i) => {
        if (e?.name?.toLowerCase()?.startsWith("numbers")) lastNumIdx = i;
      });
      menudata.splice(lastNumIdx > -1 ? lastNumIdx + 1 : menudata.length, 0, authItem);
    }
  }
  const hexToRgb = (hex) => {
    // Remove the leading '#' if present
    hex = hex?.replace(/^#/, "");

    // Parse the hex value into its RGB components
    let bigint = parseInt(hex, 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;

    return `${r}, ${g}, ${b}`;
  };

  let currentMainMenuName = "";
  menudata?.forEach((e) => {
    if (e?.subRoutes) {
      e.subRoutes.forEach((subRoute) => {
        if (location.pathname === subRoute.path) {
          currentMainMenuName = e.name;
        }
      });
    } else if (location.pathname === e?.path) {
      currentMainMenuName = e.name;
    }
  });
  // console.log(`[INFO] Current Main Menu is "${currentMainMenuName}"`);

  return (
    <div
      style={{ backgroundColor: theme.sideMenuColor }}
      className={`transition-all duration-300 ease-in-out h-100vh pb-[28px] flex flex-col fixed top-0 bottom-0 overflow-y-scroll
        ${collapsed ? `w-[70px] ` : `w-[221px]`}`}
    >
      <Closeicon
        onClick={closeSidebar}
        className="h-[20px] w-[20px] fixed top-[15px] ltr:left-[170px] rtl:right-[170px] lg:hidden cursor-pointer"
      />

      <div className=" sticky top-24 ltr:ml-auto rtl:mr-auto w-3 z-10">
        <button
          className={`w-3 h-4 justify-center flex place-items-center bg-red-500 w-[22px] h-[22px] rounded-full fixed top-[72px] transition-transform duration-300 ease-in-out transform ${
            !collapsed ? "rotate-180" : ""
          }`}
          style={{
            boxShadow: "0px 0px 4px #0000004D",
          }}
          onClick={() => {
            setCollapsed(!collapsed);
          }}
        >
          <RightArrow className="h-2 w-2" style={{ color: "white" }} />
        </button>
      </div>
      <div
        className="top-0 sticky mb-6"
        style={{ backgroundColor: theme.sideMenuColor }}
      >
        <div
          style={{ minHeight: 64 }}
          className="flex items-center  justify-center"
        >
          <Link
            to="/app/home"
            className={`transition-all duration-300 ease-in-out flex justify-center  w-full ${
              collapsed ? "px-4" : "mx-4"
            }`}
          >
            {collapsed ? (
              <img
                key={1}
                className="h-full w-auto"
                src={theme.faviconUrl ? theme.faviconUrl : ComvivaLogo}
                alt="Favicon"
              />
            ) : (
              <img
                key={2}
                className=" h-full w-auto mx-0"
                src={theme.logos ? theme.logos : ComvivaLogo}
                style={{
                  maxHeight: "125px",
                }}
                alt="Logo"
              />
            )}
          </Link>
        </div>
        <div className="px-6">
          <hr
            style={{
              borderTop: `1px solid rgba(${hexToRgb(
                theme?.menuTextColor
              )}, 0.2)`,
            }}
          ></hr>
        </div>
      </div>
      {/* if 'routes', change below 'routes' to 'menudata' after testing */}
      {menudata?.map((route, i) => {
        if (route.name) {
          isLineAdded = false;

          return (
            <MENU
              route={route}
              key={`${route.name}${i}`}
              currentMainMenuName={currentMainMenuName}
            />
          );
        } else {
          if (!isLineAdded) {
            isLineAdded = !isLineAdded;
            return (
              <div className="px-6 py-6" key={`${route.name}${i}`}>
                <hr
                  style={{
                    borderTop: `1px solid rgba(${hexToRgb(
                      theme?.menuTextColor
                    )}, 0.2)`,
                  }}
                ></hr>
              </div>
            );
          } else {
            return <div key={i}></div>;
          }
        }
      })}
    </div>
  );
}

export default SidebarContent;
